import { create } from 'zustand'
import { trackApplicationFormOpen } from '@/utilities/analytics'

export type ApplicationType = 'civil' | 'military'

interface ApplicationModalState {
  isOpen: boolean
  applicationType: ApplicationType
  positionSlug: string | null
  openModal: (type?: ApplicationType, positionSlug?: string | null) => void
  closeModal: () => void
  setApplicationType: (type: ApplicationType) => void
}

export const useApplicationModalStore = create<ApplicationModalState>((set) => ({
  isOpen: false,
  applicationType: 'civil',
  positionSlug: null,
  openModal: (type = 'civil', positionSlug = null) => {
    // Track form open event
    trackApplicationFormOpen(positionSlug || undefined)
    set({
      isOpen: true,
      applicationType: type,
      positionSlug,
    })
  },
  closeModal: () =>
    set({
      isOpen: false,
      positionSlug: null,
    }),
  setApplicationType: (type) => set({ applicationType: type }),
}))
